import { useEffect } from 'react';

import { useAuth } from '@/state/auth';

function Logout() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, []);

  return (
    <div className="bg-chariot-background-primary bg-gradient fixed top-0 left-0 z-999 size-full"></div>
  );
}

export default Logout;
